import { PerformanceAnalysisDTO } from "./performanceAnalysisDTO";

export class DisplayCalculationInfo{
  title : string = "";
  displayLegend : boolean = false;
  legendTitle: string = "";
  displaySecondChart: boolean = true;
  displayWorstInertialChart: boolean = true;
  displayCenterInertialChart: boolean = true;
  displayTable: boolean = false;
  displayContinuity: boolean = true;
  displayLeftColumnInfomation : boolean = true;

  static getPerformanceAnalysisDisplay(performanceAnalysisDTO: PerformanceAnalysisDTO): DisplayCalculationInfo{
    let result = new DisplayCalculationInfo();
    result.displaySecondChart = false;
    result.displayWorstInertialChart = false;
    result.displayCenterInertialChart = false;
    result.displayLegend = performanceAnalysisDTO.resultanalysis == "bar";
    switch(performanceAnalysisDTO.performanceType){
      case 0:
        result.legendTitle = "Subtended Angle Legend"
        result.title = "Subtended Angle Information";
        result.displayTable = false;
        break;
      case 1:
        result.legendTitle = "Redundancy Legend"
        result.title = "Redundancy Information";
        result.displayTable = true;
        break;
      case 2:
        result.legendTitle = "Navigation System Error Legend"
        result.title = performanceAnalysisDTO.receiverDelay? "NSE Information (Considering receiver delay)" : "NSE Information";
        result.displayTable = false;
        result.displayLegend = true;
        result.displaySecondChart = performanceAnalysisDTO.resultanalysis == "plot";
        if(performanceAnalysisDTO.isInertialDrift){
          result.displayWorstInertialChart = true;
          result.displayCenterInertialChart = true;
        }
        break;
    }
    return result;
  }
  static getVerticalProfileDisplay(): DisplayCalculationInfo{
    let result = new DisplayCalculationInfo();
    result.title = "Procedure Vertical Profile Graph";
    result.displaySecondChart = false;
    result.displayWorstInertialChart = false;
    result.displayCenterInertialChart = false;
    result.displayLegend = false;
    result.displaySecondChart = false;
    result.displayTable = false;
    result.displayContinuity= false;
    return result;
  }

}
